import { useCallback, useEffect, useState } from 'react'
import * as authService from '../services/authService'
import { listOpenEvents } from '../services/predictionService'

const REFRESH_MS = 60_000

export function usePredictionUserEntry(predictionEnabled?: boolean) {
  const [hasOpenEvents, setHasOpenEvents] = useState(false)
  const [checked, setChecked] = useState(false)

  const refresh = useCallback(async () => {
    if (predictionEnabled !== true || !authService.isAuthenticated()) {
      setHasOpenEvents(false)
      setChecked(true)
      return
    }

    try {
      const res = await listOpenEvents()
      setHasOpenEvents((res.data?.length ?? 0) > 0)
    } catch {
      setHasOpenEvents(false)
    } finally {
      setChecked(true)
    }
  }, [predictionEnabled])

  useEffect(() => {
    setChecked(false)
    void refresh()
    const timer = window.setInterval(() => {
      void refresh()
    }, REFRESH_MS)
    return () => window.clearInterval(timer)
  }, [refresh])

  return {
    showPredictionEntry: predictionEnabled === true && hasOpenEvents,
    hasOpenEvents,
    checked,
    refresh,
  }
}
